import { render, staticRenderFns } from "./loadBalance.vue?vue&type=template&id=3e8b673a&scoped=true&"
import script from "./loadBalance.vue?vue&type=script&lang=ts&"
export * from "./loadBalance.vue?vue&type=script&lang=ts&"
import style0 from "./loadBalance.vue?vue&type=style&index=0&id=3e8b673a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b673a",
  null
  
)

export default component.exports